import { render, staticRenderFns } from "./AdminInsert.vue?vue&type=template&id=179cd101&scoped=true&"
import script from "./AdminInsert.vue?vue&type=script&lang=js&"
export * from "./AdminInsert.vue?vue&type=script&lang=js&"
import style0 from "./AdminInsert.vue?vue&type=style&index=0&id=179cd101&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179cd101",
  null
  
)

export default component.exports